export default __webpack_public_path__ + "static/media/capsicum.e0c24aa0.png";